import React from 'react';
import {JobCost} from 'components/customer/Job/store/jobApi';
import {formatPrice} from 'shared/helpers';
import {useJobContext} from 'contexts/JobContext';
import {PartialJob} from 'shared/types/PartialJob';
import {deliveryExtraRows} from 'shared/components/Header/Cost/LegacyCost';

interface CostBreakdownSimpleProps {
    cost: JobCost;
    isLoadingCost: boolean;
    isFetchingCost: boolean;
}

export const CostBreakdownSimple = ({
    cost,
    isLoadingCost,
    isFetchingCost,
}: CostBreakdownSimpleProps) => {
    const {job} = useJobContext() as PartialJob;

    if (cost) {
        return (
            <>
                <li>
                    <span>Job Subtotal:</span>
                    {!isLoadingCost || !isFetchingCost
                        ? formatPrice(
                              cost.preliminaryJobCost -
                                  cost.packagingOptionsCost,
                              cost
                          )
                        : '...'}
                </li>

                {!isLoadingCost &&
                    !isFetchingCost &&
                    deliveryExtraRows(cost.packagingOptions, cost)}

                <li>
                    <span>{job?.countryTaxRateName}:</span>
                    <span>
                        {cost && (!isLoadingCost || !isFetchingCost)
                            ? formatPrice(cost.preliminaryTax, cost)
                            : '...'}
                    </span>
                </li>
                <li className="cost">
                    <span>Preliminary Cost:</span>
                    <span>
                        {cost && (!isLoadingCost || !isFetchingCost)
                            ? formatPrice(cost.preliminaryJobCostInclTax, cost)
                            : '...'}
                    </span>
                </li>
            </>
        );
    }
};
